import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  InputLabel,
  Input,
  FormControl,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const ResourcesForm = (props) => {
  const [values, setValues] = useState({
    typeOfDocument: "",
    document: "",
  });
  const [typeError, setTypeError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [saveDetailsLoading, setDetailsSaveLoading] = useState(false);

console.log({typeValue : props.tabval})

  const handleChange = (event) => {
    const newInput = event.target.value;
    if (!newInput || newInput.length === 0) {
      setTypeError(true);
    } else {
      setTypeError(false);
    }
    setValues({
      ...values,
      typeOfDocument: event.target.value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file || file.length === 0) {
      setFileError(true);
    } else {
      setFileError(false);
    }
    setValues({
      ...values,
      document: file,
    });
  };


  const saveHandler = async (e) => {
    e.preventDefault();

    if (!values.typeOfDocument || values.typeOfDocument.length === 0) {
      setTypeError(true);
      return;
    }
    if (!values.document) {
      setFileError(true);
      return;
    }
    setDetailsSaveLoading(true);
    const formData = new FormData();
    formData.append("media", values.document);
    formData.append("resourceType", values.typeOfDocument);
    formData.append("type", props.tab);


    try {
      const response = await axios.post(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/resources/post-document",
        formData
      );
      await props.getAllResources();
      console.log(response.data);
      setValues({
        typeOfDocument: "",
        document: "",
      });
      setDetailsSaveLoading(false);
      const alertAllUsers = await axios.get(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/resources/send-new-upload-push-notification"
      );
      console.log(alertAllUsers);
    } catch (error) {
      console.error("Error saving document:", error);
    } finally {
      setDetailsSaveLoading(false);
    }
  };

  return (
    <form>
      <Card>
        <CardHeader title="Upload Document" />
        <Divider />
        <CardContent>
          {!typeError ? (
            <TextField
              style={{ width: "100%" }}
              margin="dense"
              size="large"
              type="text"
              label="Type of document"
              value={values.typeOfDocument}
              variant="outlined"
              onChange={handleChange}
              name="typeOfDocument"
            />
          ) : (
            <TextField
              error
              fullWidth
              type="text"
              label="Please Enter Type of document."
              name="typeOfDocument"
              style={{ width: "100%" }}
              margin="dense"
              onChange={handleChange}
              required
              value={values.typeOfDocument}
              variant="outlined"
              // helperText="Please Enter Your Name."
            />
          )}
          <br />
          {/* {!fileError ? (
            <TextField
              style={{ width: "100%", margin: "5px" }}
              type="url"
              label="Url"
              value={values.document}
              name="document"
              variant="outlined"
              onChange={handleChange}
            />
          ) : (
            <TextField
              error
              style={{ width: "100%", margin: "5px" }}
              type="url"
              label="Please enter url"
              value={values.document}
              name="document"
              variant="outlined"
              onChange={handleChange}
            />
          )} */}
          <div>
            <input
              accept=".pdf"
              // className={classes.input}
              id="contained-button-file"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{ marginTop: "20px" }}
              >
                Select Document
              </Button>
            </label>
          </div>
          {values?.document?.name && (
            <p style={{ marginLeft: "10px" }}>{values?.document?.name}</p>
          )}
          {fileError && (
            <label
              style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
            >
              * Please select a file
            </label>
          )}
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={saveHandler}
            style={{ backgroundColor: "rgb(80, 72, 229)" }}
          >
            Submit{" "}
            {saveDetailsLoading && (
              <CircularProgress
                style={{
                  width: "22px",
                  height: "22px",
                  marginLeft: "5px",
                }}
                color="inherit"
              />
            )}
          </Button>
        </Box>
      </Card>
    </form>
  );
};

export default ResourcesForm;
